import React, { useState } from 'react';
import { login } from './api/movies';
import { Button } from './components/Button';
import { Flex } from './components/Flex';
import { Input } from './components/Input';
import { Meta } from './Meta';

export function LoginPage({}) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  async function performLogin() {
    var loggedIn = await login({ username: username, password: password });
    if (loggedIn) {
      window.location.reload();
    }
  }

  return (
    <Flex
      className="login-wrapper"
      justify="center"
      align="center"
      direction="row"
    >
      <Meta subtitle="Login" />
      <Flex className="login" direction="column" gap="0.75rem">
        <Input
          label="User"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <Input
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button variant="primary" onClick={performLogin}>
          Login
        </Button>
      </Flex>
    </Flex>
  );
}
